import React from 'react';
import styled from 'styled-components';

import useMobileView from '@design-system/hooks/useMobileView';
import useRegionConfig from '@source/hooks/useRegionConfig';
import { FEATURED_IN } from '../../constants';

const StyledWrapper = styled.div<{ isMY?: boolean }>`
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  flex-wrap: wrap;
  row-gap: 20px;
  margin-top: ${(props) => (props.isMY ? '25px' : '43px')};

  @media (min-width: 768px) {
    gap: 16px;
    margin-top: ${(props) => (props.isMY ? '23.5px' : '43px')};
  }

  @media (min-width: 1280px) {
    flex-wrap: nowrap;
    gap: 44px;
    margin-top: ${(props) => (props.isMY ? '11.5px' : '43px')};
  }
`;

const StyledItem = styled.div`
  flex-shrink: 1;
`;

const CCPOFeaturedIn = () => {
  const {
    countryConfig: { country },
  } = useRegionConfig();
  const isMobile = useMobileView(992);
  const featuredIn = FEATURED_IN[isMobile ? 'mobile' : 'desktop'];

  return (
    <StyledWrapper isMY={country === 'my'}>
      {featuredIn.map((img) => {
        // eslint-disable-next-line react/no-array-index-key
        let style = {};

        if (img.key === 'channelasia' && !isMobile) {
          style = { transform: 'translateY(-10px)' };
        } else if (img.key === 'businesstimes' && isMobile) {
          style = { transform: 'translateY(2.5px)' };
        }

        return (
          <StyledItem key={img.alt} style={style}>
            {/* eslint-disable-next-line @next/next/no-img-element */}
            <img style={{ maxWidth: img.width, width: '100%', height: 'auto' }} src={img.url} alt={img.alt} />
          </StyledItem>
        );
      })}
    </StyledWrapper>
  );
};

export default CCPOFeaturedIn;
